import { UnitTable } from 'components';
import { Paths, UnitType } from 'constants/index';

const Table = () => {
  return (
    <UnitTable path={Paths.ADMIN_LABORATORIES_VIEW} type={UnitType.LABORATORY} />
  );};

export default Table;
